import React, { useContext } from 'react';
import AuthContext from '../../../contexts/authContext';
import AdminDashboard from './AdminDashboard';
import HodDashboard from './HodDashboard';
import AccountantDashboard from './AccountantDashboard';
import StaffDashboard from './StaffDashboard';
import StudentDashboard from './StudentDashboard';

const DashboardPage = () => {
	const { userTypeId } = useContext(AuthContext);

	if (userTypeId == 1 || userTypeId == 2) {
		return <AdminDashboard />;
	}
	if (userTypeId == 6 || userTypeId == 3) {
		return <HodDashboard />;
	}
	if (userTypeId == 8) {
		return <AccountantDashboard />;
	}
	if (userTypeId == 7) {
		return <StaffDashboard />;
	}
	if (userTypeId == 10) {
		return <StudentDashboard />;
	}

	return null;
};

export default DashboardPage;